/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
    created() {}

    mounted() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/footer/index.ts